import { Box, Container } from "@mui/material";
import React, { FC } from "react";
import useResponsive from "../hooks/useResponsive";

const DashboardContentLayout: FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const isMedium = useResponsive("down", "md", "xl");
  return (
    <Container sx={{}}>
      <Box
        sx={{
          width: "90%",
          marginLeft: isMedium ? "0px" : "120px",
        }}
      >
        {children}
      </Box>
    </Container>
  );
};

export default DashboardContentLayout;
